



























































































import {Component, Prop, Vue} from "vue-property-decorator";

import productApi from "@/api/productApi";
import PaginateModel from "@/model/paginate";
import Product, { Category } from "@/model/product";
import categoryApi from "@/api/categoryApi";
import ProductDetail from "@/components/cutomer/productDetail.vue";
import QPaginate from "@/common/qPaginate.vue";
import ProductPopup from "@/components/cutomer/productPopup.vue";
import {CartItemList} from "@/model/cart";

@Component({
  name: "productListPopup",
  components: {
    ProductDetail,
    QPaginate,
    ProductPopup,
  },
})
export default class productListPopup extends Vue {
  @Prop({
    type: CartItemList,
    default() {
      return new CartItemList();
    },
  })
  itemsList;

  public isShow = false;
  public categories: Category[] = [];
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });
  public products: Product[] = [];
  public search = {
    item_code: "",
    item_name_1: "",
    item_name_2: "",
    cart_cate_code: null,
  };

  mounted() {
    this.getCategories();
  }

  show() {
    this.isShow = true;
    this.resetSearch();
  }

  public async getCategories() {
    this.categories = await categoryApi.all({
      all: true
    });
  }

  public async doSearch(query: any) {
    const result = await productApi.getAll({ ...query, is_publish: true });

    this.pagination = result.paginate;
    this.products = result.list;
  }

  public resetSearch() {
    this.search = {
      item_code: "",
      item_name_1: "",
      item_name_2: "",
      cart_cate_code: null,
    };
    this.filter({ page: 1 });
  }

  public filter(addition = {}): void {
    this.doSearch({ ...this.search, ...addition });
  }

  public showDetail(product: Product) {
    (this.$refs.productPopup as ProductPopup).show(product);
  }

  public async addItems(items) {
    this.$emit('addItems' , items);
    this.isShow = false;
  }
}
